import { startTransition } from "react";
import {
  Box,
  Grid,
  Tab,
  Tabs,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const WidgetSelectorTabs = ({
  widgets,
  activeTabId,
  onWidgetSelect
}) => {
  const { t } = useTranslation();
  
  const handleTabChange = (e, val) => {
    startTransition(() => {
      onWidgetSelect(val);
    });
  }
  
  return (
    <Grid 
      sx={{
        maxWidth: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 3,
        backgroundColor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Box 
        sx={{ 
          px: {
            xs: 1,
            sm: 2,
            md: 3,
          },
        }}
      >
        <Tabs
          value={activeTabId || false}
          onChange={handleTabChange}
          // variant="scrollable"
          scrollButtons="auto"
          aria-label="Выбор виджета"
        > 
          {
            widgets.map((widget) => (
              <Tab 
                value={widget.id}
                label={t(widget.translateKey)}
                key={widget.id}
              />
            ))
          }
        </Tabs>
      </Box>
    </Grid>
    )
}

export default WidgetSelectorTabs;
